function o(o2) {
  const r = o2.match(/^(?<variant>plain|outlined|soft|solid)?(?<size>sm|md|lg)?(?<color>primary|neutral|danger|success|warning)?$/i), i = { variant: void 0, size: void 0, color: void 0 };
  if (r == null ? void 0 : r.groups) {
    const { variant: o3, size: a, color: s } = r.groups;
    o3 && (i.variant = o3.toLowerCase()), a && (i.size = a.toLowerCase()), s && (i.color = s.toLowerCase());
  }
  return i;
}
export {
  o as parseDesignVariant
};
